export const WATERMARK_POSITIONS = {
  TOP_LEFT: 'TOP_LEFT',
  TOP_RIGHT: 'TOP_RIGHT',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT',
};

export const WATERMARK_POSITION_OPTIONS = [
  { value: WATERMARK_POSITIONS.TOP_LEFT, label: '左上角' },
  { value: WATERMARK_POSITIONS.TOP_RIGHT, label: '右上角' },
  { value: WATERMARK_POSITIONS.BOTTOM_LEFT, label: '左下角' },
  { value: WATERMARK_POSITIONS.BOTTOM_RIGHT, label: '右下角' },
];
